import { render, staticRenderFns } from "./FlowInforPanelHeader.vue?vue&type=template&id=1ef0dc96"
import script from "./FlowInforPanelHeader.vue?vue&type=script&lang=js"
export * from "./FlowInforPanelHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports